import React, { useState, useEffect } from 'react';
import './Announcements.css';
import announcementsBg from '../assets/background/Announcements.webp';

const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://psychology-maps-2-0-backend.vercel.app/api/announcements');
      const data = await response.json();

      if (data.success) {
        setAnnouncements(data.announcements);
      } else {
        setError('Failed to load announcements');
      }
    } catch (error) {
      setError('Error loading announcements');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="announcements-container">
        <div className="announcements-loading">
          <div className="loading-spinner"></div>
          <p>Loading announcements...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="announcements-container">
      {/* Hero Section */}
      <section className="announcements-hero">
        <div className="hero-background">
          <img src={announcementsBg} alt="" />
        </div>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="content">
            <div className="hero-text">
              <div className="padding">
                <h1>Announcements</h1>
                <h2>Stay Updated</h2>
                <p>Stay updated with the latest news and important information from the MPSc program.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Announcements Section */}
      <section className="featured-announcements-section">
        <div className="container">
          {error && (
            <div className="announcements-error">
              <i className="fas fa-exclamation-circle"></i>
              <span>{error}</span>
            </div>
          )}

          {announcements.length > 0 && (
            <>
              <div className="section-header">
                <div className="section-icon">
                  <i className="fas fa-bullhorn"></i>
                </div>
                <h2>Announcements</h2>
              </div>
              <div className="featured-grid">
                {announcements.map((announcement, index) => (
                  <div 
                    key={announcement._id} 
                    className="featured-card"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    {announcement.isFeatured && (
                      <div className="featured-badge">
                        <i className="fas fa-star"></i>
                        <span>Featured</span>
                      </div>
                    )}
                    <div className="card-content">
                      <h3>{announcement.title}</h3>
                      <div className="card-date">
                        <i className="fas fa-calendar-alt"></i>
                        <span>{formatDate(announcement.datePosted)}</span>
                      </div>
                      <div className="card-text">{announcement.content}</div>
                      {announcement.expiryDate && (
                        <div className="card-expiry">
                          <i className="fas fa-clock"></i>
                          <span>Expires: {formatDate(announcement.expiryDate)}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {announcements.length === 0 && !error && (
            <div className="announcements-empty">
              <div className="empty-icon">
                <i className="fas fa-inbox"></i>
              </div>
              <h3>No Announcements</h3>
              <p>There are no announcements available at this time. Please check back later.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Announcements;

